import { action } from "typesafe-actions";
import { ICategory } from "./category.types";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import {
	saveLoaderCompleted,
	saveLoaderProgress,
	showMessage,
} from "../messages/messagesActions";
import { api } from "../../api/api";

export const FETCH_CATEGORY_LIST_PROGRESS = "FETCH_CATEGORY_LIST_PROGRESS";
export const FETCH_CATEGORY_LIST_SUCCESS = "FETCH_CATEGORY_LIST_SUCCESS";
export const FETCH_CATEGORY_LIST_FAILED = "FETCH_CATEGORY_LIST_FAILED";

export const fetchCategoryListProgress = () =>
	action(FETCH_CATEGORY_LIST_PROGRESS);
export const fetchCategoryListSuccess = (
	data: ICategory[],
	totalRecords: number
) =>
	action(FETCH_CATEGORY_LIST_SUCCESS, {
		data,
		totalRecords,
	});
export const fetchCategoryListFailed = () => action(FETCH_CATEGORY_LIST_FAILED);

export const fetchCategoryListAsync =
	(
		pageNumber: number,
		rowsInPerPage: number,
		status: string,
		date: IDataTableV2DateState["dates"],
		searchValue: IDatatableV2AdvancedSearchFilter
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
	async (dispatch, getState) => {
		try {
			// const searchQuery = getSearchQuery(queryParams);
			dispatch(fetchCategoryListProgress());
			dispatch(saveLoaderProgress());

			let url = "";
			if (status !== "-1") {
				url += `&status=${status}`;
			}
			if (searchValue.length > 0) {
				url += `&advanceFilter=${JSON.stringify(searchValue)}`;
			}

			let finalUrl =
				`/food/get-food-category?pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}` +
				url;
			const res = await api.get(finalUrl);
			const data: ICategory[] = res.data.data;
			const totalRecords = res.data.totalRecords;

			dispatch(fetchCategoryListSuccess(data, totalRecords));
		} catch (err: any) {
			dispatch(fetchCategoryListFailed());
			dispatch(
				showMessage({
					type: "error",
					message: err.response.data.message,
					displayAs: "snackbar",
				})
			);
		} finally {
			dispatch(saveLoaderCompleted());
		}
	};
export const upsertCategoryAsync =
	(
		data: ICategory,

		onCallback: (isSuccess: boolean) => void
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
	async (dispatch, getState) => {
		try {
			dispatch(saveLoaderProgress());

			await api.post("/food/upsert-food-category", {
				...data,
			});

			const message = "Category saved successfully.";
			dispatch(
				showMessage({
					type: "success",
					message: message,
					displayAs: "snackbar",
				})
			);
			onCallback(true);
		} catch (err: any) {
			onCallback(false);
			dispatch(
				showMessage({
					type: "error",
					message: err.response.data.message,
					displayAs: "snackbar",
				})
			);
		} finally {
			dispatch(saveLoaderCompleted());
		}
	};

export const CLEAR_CATGEORY_STATE = "CLEAR_CATGEORY_STATE";
export const clearCategoryState = () => action(CLEAR_CATGEORY_STATE);
